module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Born and brought up in North Cornwall, Sally and siblings spent many days outside. Nature and the environment are crucial to her happiness and well-being.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Having qualified as an Early Years teacher, she moved to the Midlands to teach, whilst raising her own family. Being outdoors was an important part of their family dynamic.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("During her teaching career, Sally’s favourite part of the day was telling stories and watching the children’s faces as they escaped into imaginary worlds.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Since retiring, Sally has been able to focus on writing and through her books hopes to take the readers on a delightful journey, where both adults and children can engage in unique activities together.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB2.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "Copyright-heading",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Copyright © Sally McGuiness 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("The right of ")]), _c('span', {
    staticClass: "CharOverride-3",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("Sally McGuiness")]), _c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v(" to be identified as author of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("A CIP catalogue record for this title is available from the British Library.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("ISBN 9781035808366 (Paperback)")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("ISBN 9781035808373 (Hardback)")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("ISBN 9781035808380 (ePub e-book)")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("www.austinmacauley.com")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("First Published 2024")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("Austin Macauley Publishers Ltd")]), _c('span', {
    staticClass: "CharOverride-4",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("®")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("1 Canada Square ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("Canary Wharf")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("London")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2",
    attrs: {
      "lang": ""
    }
  }, [_vm._v("E14 5AA")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "Ded",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("This book is dedicated to my parents firstly, who saw fit to raise me in beautiful unspoilt surroundings and taught me about the natural world around me.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Secondly, I dedicate it to my nuclear family, my sons; Martin and Neil, and husband; John, with whom I spent many happy hours walking, picnicking, playing in the countryside. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("And lastly to my daughters-in-law; Gemma and Monica, who are joining us in this adventure, and bringing along another generation.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thanks are due in particular to my sons who have given me confidence to do this and have loved and supported me whilst I have been doing it. Also to Monica who has done all the illustrations of my prose.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1",
    attrs: {
      "lang": "en-GB",
      "xml:lang": "en-GB"
    }
  }, [_vm._v("Thanks too to Austin Macauley for having faith in me and in making this a reality.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB6.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer007"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer009"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB3.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer011"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB4.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer013"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB5.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer015"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB7.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer017"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB8.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer019"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB9.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer021"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB10.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer023"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB11.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer025"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer026"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB12.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer027"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB13.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer029"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB14.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer031"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer032"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB15.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer033"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB16.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer035"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer036"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB17.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer037"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer038"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB18.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer039"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer040"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB19.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer041"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer042"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB20.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer043"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer044"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB21.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer045"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer046"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB22.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer047"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer048"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB23.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer049"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer050"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB24.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer051"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer052"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB25.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer053"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer054"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB26.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer055"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer056"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB27.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer057"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer058"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB28.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer059"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer060"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB29.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer061"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer062"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/9781035808380_EPUB30.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1668fc5b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781035808380_EPUB_3.vue
// module id = 57
// module chunks = 0